export default __webpack_public_path__ + "static/media/subscription.aa85b100.svg";